import Header from './layout/header';
import Main from './layout/main';
function App() {
  return (
    <div className="App">
        <Header />
        <Main />
    </div>
  );
}

export default App;
